<template>
	<div class="touch-icon">
		<svg class="icon touch-border">
			<use href="#touchCircle"></use>
		</svg>
		<div class="touch-bg"></div>
		<img src="@/images/icons/touch.png" alt="">
	</div>
</template>
